import Constants, { OPTIONS_IDS } from '../data/Constants';

const initialState = {
  // contains positions coordinates of two draggable options
  draggableLayouts: {
    [OPTIONS_IDS.OPTION_1]: {},
    [OPTIONS_IDS.OPTION_2]: {},
    [OPTIONS_IDS.OPTION_3]: {},
  },
  // permit options dragging
  lockInteractions: false,
  // contains text for both draggables
  slotTexts: ['', ''],
  // id of correct chevron slot for both draggables
  correctSlotIds: [0, 0],
  // defines if any option is grabbed at the moment
  draggableIsGrabbed: false,
  grabbedOptionId: null,
  hoveredChevronId: null,
};

const draggableLayoutsReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'INIT_ONBOARDING':
    case 'INIT_LEVEL':
      return initialState;

    case 'SET_LOCK_INTERACTIONS':
      return {
        ...state,
        lockInteractions: action.payload.lockInteractions,
      };
    case 'SET_DRAGGABLE_LAYOUT':
      return {
        ...state,
        draggableLayouts: { ...state.draggableLayouts, [action.payload.optionId]: action.payload.layout },
      };
    case 'SET_UP_SLOTS':
      return {
        ...state,
        slotTexts: [action.payload.slotOneText, action.payload.slotTwoText, action.payload.slotThreeText],
        correctSlotIds: [action.payload.correctSlotOneId, action.payload.correctSlotTwoId],
      };
    case 'SET_DRAGGABLE_IS_GRABBED': {
      const { draggableIsGrabbed, optionId } = action.payload;
      return {
        ...state,
        draggableIsGrabbed,
        grabbedOptionId: draggableIsGrabbed ? optionId : null,
      };
    }
    case 'SET_HOVERED_CHEVRON_ID':
      return {
        ...state,
        hoveredChevronId: action.payload.hoveredChevronId,
      };
    case 'LOAD_NEW_QUESTION':
      return {
        ...state,
        hoveredChevronId: null,
      };
    default:
      return state;
  }
};

export default draggableLayoutsReducer;
